import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { Accounts } from '@mews-commander/financial-services';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/FinancialServices/Accounts')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.financialServicesEnabled);
    },
    component: Accounts,
    staticData: {
        title: TextKey.FinancialServices,
        owner: MewsTeam.FinancialServices,
        type: RouteType.Frontend,
    },
});
